import { FeatureFlag } from '../FeatureFlag';

/**
 * Controls whether alert notification sounds (and TTS) play even when a toast
 * for the same alert is already visible.
 *
 * - `true`: sounds and TTS always play; only toast messages are deduplicated.
 * - `false` (default): sounds, TTS, and toasts are all suppressed while a
 *   toast for the same alert is still active.
 */
export const alwaysPlayAlertSounds = new FeatureFlag({
    key: 'always-play-alert-sounds',
    defaultValue: false,
});
